import { useTranslation } from 'react-i18next';
import IntegrationsTable from 'pages/integrations/components/integrationTable/IntegrationsTable';
import TabHeader from '../../components/tabHeader/TabHeader';

const IntegrationsAllTab = () => {
  const { t } = useTranslation();

  return (
    <section>
      <TabHeader tabName={t('pageIntegrations.tabNames.all')} />
      <IntegrationsTable />
    </section>
  );
};

export default IntegrationsAllTab;
